module.exports = __webpack_public_path__ + "facelifting_6_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/facelifting_6_before.jpg
// module id = 1060
// module chunks = 0